import React, { Component } from 'react';
import axios from 'axios';
import Item from '../../components/Item/Item';
import Filters from '../../components/Filters/Filters';


class FeedComponent extends Component {
   constructor(props) {
      super(props);
      this.state = {
         newsItems: [],
         allItems: [],
         specialties: [],
         filterName: '',
         filterSpecialty: ''
      };
      axios.get("https://"+window.location.hostname+"/prodigy-surgical-news-feed/json.php").then(result => {
        //  console.log(result.data);
        //  console.log(result.data.channel.item);
         
         this.setState({
            newsItems: result.data.channel.item,
            allItems: result.data.all_items,
            specialties: result.data.specialties
         });

      });
   }

   nameChangeHandler = (event) => {
      this.setState({ filterName: event.target.value });
   }

   specialtyChangeHandler = (event) => {
      this.setState({ filterSpecialty: event.target.value });
   }

   matchesFilters = (item) => {
      let matches = true;
      if(!(item.title.toLowerCase()).includes(this.state.filterName.toLowerCase())) {
         matches = false;
      }
      if(this.state.filterSpecialty !== '' && !item.specialty.includes(this.state.filterSpecialty)) {
         matches = false;
      }
      return matches;
   }
   
   render() {
      let itemCount = 0;
      let outputItems = [];
      if(this.state.filterName === '' && this.state.filterSpecialty === '') {
         outputItems = this.state.newsItems;
      } else {
         outputItems = Object.values(this.state.allItems);
      }
      const items = outputItems.map((item) => {
         const title = item.title;
         const itemOutput = (
            <Item key={title+item.description}
            itemData={item}
            />
         );
         
         if(this.matchesFilters(item)) {
            itemCount++;
            return itemOutput;
         } else {
            return null;
         }

      });
      return (
         <div className="App">
         	<section class="news_filter_wrapper">
					<Filters 
						specialties={this.state.specialties}
						filterName={this.state.filterName}
						filterSpecialty={this.state.filterSpecialty}
						nameChange={this.nameChangeHandler}
						specialtyClick={this.specialtyChangeHandler}
					/>
          	</section>

				<section class="open_positions_wrapper">
					<div class="open_positions news">
						{ items }
					</div>
				</section>
         </div>
      );
  }
}

export default FeedComponent;



// WEBPACK FOOTER //
// ./src/containers/Feed/Feed.js